var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { updateMedicationDaaDosageInstruction, updateMedicationDosageTimesOrderInstruction, updateMedicationFreeTextDosageInstruction, updateMedicationFreeTextOrderInstruction } from '../../../Async/MedicationsSummaryAsync';
import { InstructionType, MedicationType } from '../../../Contracts/MedicationModels';
import { isDaaInstruction, isDosageTimesInstruction, isFreeTextInstruction } from '../../../Contracts/PatientMedication.Response';
import { MedicationOverviewSection } from '../../MedicationOverviewSection';
import { prettyPrintDosageInstructionLabel, prettyPrintOrderInstructionLabel } from '../../../Shared/MedicationSharedMethods';
import { DaaRequired, DaaSelectorField } from '../DaaSelectorField';
import { DaaInstructionForm } from './DaaInstructionForm';
import { DosageTimesInstructionForm } from './DosageTimesInstructionsForm';
import { FreeTextInstructionsForm } from './FreeTextInstructionsForm';
import { WrapInMedicalLabel } from './MedicalLabelForm';
import styles from './DosageInstructionsSection.module.css';
import classNames from 'classnames';
import { ValidDateFormats } from '../../../Shared/DateUtilities';
import moment from 'moment-timezone';
export var DosageInstructionsSection = function (props) {
    var _a;
    var _b, _c;
    return (React.createElement(MedicationOverviewSection, { index: props.index, hideSection: props.hideSection, title: props.currentMedicationType === MedicationType.MedicationOrder ||
            props.currentMedicationType === MedicationType.EnrmcScript ||
            props.currentMedicationType === MedicationType.ComplementaryTherapyOrder
            ? 'Order instructions'
            : 'Dosage instructions', titleInput: props.currentMedicationType === MedicationType.TakeHomeScript && (React.createElement(DaaSelectorField, { readOnly: props.readOnly, daaRequired: ((_c = (_b = props.patient) === null || _b === void 0 ? void 0 : _b.dosageInstruction) === null || _c === void 0 ? void 0 : _c.type) === InstructionType.DaaInstruction
                ? DaaRequired.Yes
                : DaaRequired.No, currentMedicationType: props.currentMedicationType, onChange: props.changeDaaRequired })), border: props.border },
        React.createElement("div", { className: classNames((_a = {},
                _a[styles.dosageInstructionFieldContainer] = props.currentMedicationType !== MedicationType.TakeHomeScript,
                _a)) },
            React.createElement(DosageInstructionField, __assign({}, props)))));
};
export var InstructionPositions;
(function (InstructionPositions) {
    InstructionPositions[InstructionPositions["Dosage"] = 0] = "Dosage";
    InstructionPositions[InstructionPositions["Order"] = 1] = "Order";
})(InstructionPositions || (InstructionPositions = {}));
export var InstructionField = function (props) {
    var _a, _b, _c;
    if (isDaaInstruction(props.instruction) ||
        (props.instruction === null && props.defaultInstructionType === InstructionType.DaaInstruction)) {
        return (React.createElement(DaaInstructionForm, { readOnly: props.readOnly, required: props.required, instruction: (_a = props.instruction) !== null && _a !== void 0 ? _a : {
                type: InstructionType.DaaInstruction,
                packagingType: null,
                breakfast: 0,
                lunch: 0,
                dinner: 0,
                nightTime: 0,
                additionalInstructions: '',
                instructions: '',
                textInstructions: '',
                routeOfAdministration: null
            }, postApi: function (data) { return updateMedicationDaaDosageInstruction(props.patientId, data); }, onUpdate: props.changeDosageDaa }));
    }
    else if (isFreeTextInstruction(props.instruction) ||
        (props.instruction === null && props.defaultInstructionType === InstructionType.FreeTextInstruction)) {
        return (React.createElement(FreeTextInstructionsForm, { readOnly: props.readOnly, required: props.required, requiredRouteOfAdministration: props.requiredRouteOfAdministration, label: props.label, instruction: (_b = props.instruction) !== null && _b !== void 0 ? _b : {
                type: InstructionType.FreeTextInstruction,
                instructions: '',
                textInstructions: '',
                routeOfAdministration: null
            }, postApi: function (data) {
                return props.instructionPosition === InstructionPositions.Dosage
                    ? updateMedicationFreeTextDosageInstruction(props.patientId, data)
                    : updateMedicationFreeTextOrderInstruction(props.patientId, data);
            }, onUpdate: props.instructionPosition === InstructionPositions.Dosage
                ? props.changeDosageFreeText
                : props.changeOrder }));
    }
    else if (isDosageTimesInstruction(props.instruction) ||
        (props.instruction === null && props.defaultInstructionType === InstructionType.DosageTimeInstruction)) {
        return (React.createElement(DosageTimesInstructionForm, { enableHidingOfDosageTimes: true, readOnly: props.readOnly, required: props.required, requiredRouteOfAdministration: props.requiredRouteOfAdministration, hideFrequency: props.hideFrequency, label: props.label, instruction: (_c = props.instruction) !== null && _c !== void 0 ? _c : {
                type: InstructionType.DosageTimeInstruction,
                frequency: null,
                times: [],
                instructions: '',
                textInstructions: '',
                routeOfAdministration: null,
                startsOn: moment().format(ValidDateFormats.NodeDateTimezone)
            }, postApi: function (data) { return updateMedicationDosageTimesOrderInstruction(props.patientId, data); }, onUpdate: props.changeOrder }));
    }
    return null;
};
var DosageInstructionField = function (props) {
    if (props.currentMedicationType === MedicationType.TakeHomeScript) {
        return (React.createElement(InstructionField, __assign({}, props, { label: prettyPrintDosageInstructionLabel(props.currentMedicationType), patientId: props.patient.id, readOnly: props.readOnly, required: true, instructionPosition: InstructionPositions.Dosage, instruction: props.patient.dosageInstruction, defaultInstructionType: InstructionType.FreeTextInstruction })));
    }
    if (props.currentMedicationType === MedicationType.MedicationOrder) {
        return (React.createElement(WrapInMedicalLabel, __assign({}, props),
            React.createElement(InstructionField, __assign({}, props, { label: prettyPrintOrderInstructionLabel(props.currentMedicationType), patientId: props.patient.id, readOnly: props.readOnly, required: true, instructionPosition: InstructionPositions.Order, instruction: props.patient.orderInstruction, defaultInstructionType: InstructionType.FreeTextInstruction }))));
    }
    if (props.currentMedicationType === MedicationType.EnrmcScript ||
        props.currentMedicationType === MedicationType.ComplementaryTherapyOrder) {
        return (React.createElement(InstructionField, __assign({}, props, { label: prettyPrintOrderInstructionLabel(props.currentMedicationType), patientId: props.patient.id, readOnly: props.readOnly, hideFrequency: true, required: true, requiredRouteOfAdministration: props.currentMedicationType === MedicationType.EnrmcScript, instructionPosition: InstructionPositions.Order, instruction: props.patient.orderInstruction, defaultInstructionType: InstructionType.DosageTimeInstruction })));
    }
    if (props.currentMedicationType === MedicationType.MedicationHistory) {
        return (React.createElement(InstructionField, __assign({}, props, { label: prettyPrintDosageInstructionLabel(props.currentMedicationType), patientId: props.patient.id, readOnly: props.readOnly, instructionPosition: InstructionPositions.Dosage, instruction: props.patient.dosageInstruction, defaultInstructionType: InstructionType.FreeTextInstruction })));
    }
    return null;
};
